// extracted by mini-css-extract-plugin
module.exports = {"modal":"Dialog_modal___bVb5","icon":"Dialog_icon__luz2w","title":"Dialog_title__N4J02","text":"Dialog_text__gIOtX","buttonContainer":"Dialog_buttonContainer__B8iVw"};